import React, { useEffect, useState } from "react";
import AdminDashboard from "./admindashboard";
import axios from "../api/baseurl";

import { useNavigate } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import "./Stepper.css";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEye, faTrash, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import AddPemeDetails from "./addPemeAppointments";
import "./hm-theme.css";

function BookPemeAppointments() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [labs, setLabs] = useState([]);
  const [medallBranches, setMedallBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branchLoader, setBranchLoader] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [savedDetailsList, setSavedDetailsList] = useState([]);

  const isMedallLab = (lab) => {
    if (!lab) return false;
    const name = (lab.labname || lab.name || "").trim().toLowerCase();
    return name.startsWith("medall");
  };



  const fetchingBranchesRef = React.useRef(false);

  const fetchMedallBranches = async (selectedLabObj) => {
    if (!selectedLabObj?.id) return;
    if (fetchingBranchesRef.current) return;
    fetchingBranchesRef.current = true;
    setBranchLoader(true);
    try {
      // Backend resolves labCorporateId, API URL, and auth credentials from DB
      const response = await axios.get(
        `/api/third-party-lab/${selectedLabObj.id}/branches`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const list = Array.isArray(response.data) ? response.data : [];

      setMedallBranches(list);
      if (list.length > 0) {
        setSelectedBranch(list[0]);
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
    } finally {
      setBranchLoader(false);
      fetchingBranchesRef.current = false;
    }
  };

  const token = JSON.parse(localStorage.getItem("data")).token;

  const [pemeDetails, setPemeDetails] = useState({
    labId: "",
    appointmentDate: "",
    companyId: "",
    pemeDetails: {
      fullName: "",
      phoneNumber: "",
      gender: "",
      dob: "",
      companyId: "",
      email: "",
      address: "",
      pemeDocuments: [
        {
          file: null,
          fileContentType: "",
          fileSize: "",
          fileName: ""
        }
      ],
    },
  });

  useEffect(() => {
    getCities();
    getCompanies();
  }, []);

  const getCities = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/labdetails/getUniqueCities`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCities(response.data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const getCompanies = async () => {
    try {
      const response = await axios.get(`/api/companydetails/getCompaniesByAdminlink`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCompanies(response.data);
    } catch (error) {
      handleError(error);
    }
  };

  const handleCityChange = (e) => {
    const city = e.target.value;
    setSelectedCity(city);

    if (city) {
      axios
        .post(
          `/api/labdetails/getLabsByCity`,
          { city },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then((response) => setLabs(response.data))
        .catch((error) => console.error("Error fetching labs:", error));
    } else {
      setLabs([]);
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    if (id === "appointmentDate") {
      const selectedDate = new Date(value);

      if (selectedDate.getDay() === 0) {
        toast.warn("Please select a weekday other than Sunday.");
        return;
      }
    }

    if (id === "labId") {
      const selectedLabObj = labs.find(l => String(l.id) === String(value));
      if (selectedLabObj && isMedallLab(selectedLabObj)) {
        fetchMedallBranches(selectedLabObj);
      } else {
        setMedallBranches([]);
        setSelectedBranch(null);
      }
    }

    setPemeDetails((prevState) => {
      return {
        ...prevState,
        [id]: value,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedLabObj = labs.find(l => String(l.id) === String(pemeDetails.labId));
    if (selectedLabObj && isMedallLab(selectedLabObj) && !selectedBranch) {
      toast.error("Please select a Medall branch.");
      return;
    }

    if (savedDetailsList.length === 0) {
      toast.error("Please add at least one user before submitting.");
      return;
    }
    setLoading(true);

    const requestBody = {
      labId: pemeDetails.labId,
      branchId: selectedBranch?.BranchId || null,
      branchCode: selectedBranch?.BranchCode || null,
      branchName: selectedBranch?.BranchName || null,
      appointmentDate: pemeDetails.appointmentDate,
      companyId: pemeDetails.companyId,
      pemeDetails: savedDetailsList.map(detail => ({
        fullName: detail.fullName,
        phoneNumber: detail.phoneNumber,
        gender: detail.gender,
        dob: detail.dob,
        companyId: pemeDetails.companyId,
        email: detail.email,
        address: detail.address,
        pemeDocuments: detail.pemeDocuments.map(doc => ({
          file: doc.file,
          fileContentType: doc.fileContentType,
          fileSize: doc.fileSize,
          fileName: doc.fileName
        }))
      }))
    };

    try {
      const response = await axios.post("/api/createPemeDetailsAndAppointments", requestBody, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        toast.success("PEME Appointment booked successfully");
        navigate(`/users/pemeAppointments`);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else {
        toast.error(error.response.data?.message || "An error occurred.");
      }
    } else {
      toast.error(error.message || "An error occurred.");
    }
  }

  const [selectedUser, setSelectedUser] = useState(null);

  const handleAddUser = async () => {
    if (!pemeDetails.labId || !pemeDetails.appointmentDate || !pemeDetails.companyId) {
      alert("Please fill all required fields: Lab, Appointment Date, and Company.");
      return;
    }

    try {
      const response = await axios.get(`/api/companydetails/${pemeDetails.companyId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.pemePackageId !== null) {
        setSelectedUser(null);
        setIsAddUserModalOpen(true);
      } else {
        toast.error("No package linked to this company.");
      }
    } catch (error) {
      handleError(error);
    }
  };
  const handleCloseAddUserModal = () => setIsAddUserModalOpen(false);

  const handleSaveDetails = (data) => {
    setSavedDetailsList((prevList) => {
      const existingIndex = prevList.findIndex((item) => item.id === data.id);

      if (existingIndex !== -1) {
        const updatedList = [...prevList];
        updatedList[existingIndex] = { ...prevList[existingIndex], ...data };
        return updatedList;
      } else {
        return [...prevList, data];
      }
    });
  };

  useEffect(() => {
  }, [savedDetailsList]);

  const handleRemoveUser = (index) => {
    setSavedDetailsList((prevList) => prevList.filter((_, i) => i !== index));
  };

  const handleViewUser = (user) => {
    setSelectedUser(user);
    setIsAddUserModalOpen(true);
  };

  return (
    <div>
      <AdminDashboard />
      {loading && <div className="loading"></div>}

      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">
          {/* Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">event_available</i>
                Book PEME Appointments
              </h2>
              <p className="hm-page-subtitle">
                Schedule Pre-Employment Medical Examinations and assign candidate details.
              </p>
            </div>
            <button
              type="button"
              className="btn btn-outline-secondary rounded-pill btn-sm d-flex align-items-center gap-1"
              onClick={() => navigate('/users/pemeAppointments')}
            >
              <i className="material-icons" style={{ fontSize: "1rem" }}>arrow_back</i>
              Back to Appointments
            </button>
          </div>

          {/* Form Card */}
          <div className="hm-card mb-4">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">assignment</i>
                Appointment Details
              </h3>
            </div>
            <div className="hm-card-body">
              <form onSubmit={handleSubmit}>
                <div className="row g-3 mb-4">
                  <div className="col-md-6">
                    <label className="form-label small fw-semibold">
                      City <span className="text-danger">*</span>
                    </label>
                    <select className="form-select" onChange={handleCityChange} required>
                      <option value="">Select City</option>
                      {cities.map((city, index) => (
                        <option key={index} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-semibold">
                      Lab <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      id="labId"
                      value={pemeDetails.labId}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Lab</option>
                      {labs.map((lab) => (
                        <option key={lab.id} value={lab.id}>
                          {`${lab.labname} (${lab.labcode})`}
                        </option>
                      ))}
                    </select>
                  </div>

                  {(() => {
                    const selectedLabObj = labs.find((l) => String(l.id) === String(pemeDetails.labId));
                    if (selectedLabObj && isMedallLab(selectedLabObj)) {
                      return (
                        <div className="col-md-6">
                          <label className="form-label small fw-semibold text-primary">
                            Medall Branch <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            value={selectedBranch ? selectedBranch.BranchId : ""}
                            onChange={(e) => {
                              const b = medallBranches.find((br) => String(br.BranchId) === String(e.target.value));
                              setSelectedBranch(b || null);
                            }}
                            required
                          >
                            <option value="">Select Medall Branch</option>
                            {medallBranches.map((b) => (
                              <option key={b.BranchId} value={b.BranchId}>
                                {b.BranchName} ({b.BranchCode}) - {b.CityName || ""}
                              </option>
                            ))}
                          </select>
                        </div>
                      );
                    }
                    return null;
                  })()}

                  <div className="col-md-6">
                    <label htmlFor="appointmentDate" className="form-label small fw-semibold">
                      Appointment Date <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      id="appointmentDate"
                      type="date"
                      value={pemeDetails.appointmentDate}
                      onChange={handleInputChange}
                      min={new Date().toISOString().split("T")[0]}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-semibold">
                      Company <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      id="companyId"
                      value={pemeDetails.companyId}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Company</option>
                      {companies.map((company) => (
                        <option key={company.id} value={company.id}>
                          {company.companyname}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Candidate List Header */}
                <div className="d-flex align-items-center justify-content-between mb-3 pt-3 border-top">
                  <div className="d-flex align-items-center gap-2">
                    <h5 className="mb-0 fw-bold" style={{ fontSize: "1.05rem" }}>
                      Candidates / Users
                    </h5>
                    <span className="hm-badge hm-badge-primary">
                      {savedDetailsList.length} Added
                    </span>
                  </div>
                  <button type="button" className="btn-hm-primary" onClick={handleAddUser}>
                    Add Candidate
                  </button>
                </div>

                {/* Candidate Table Container */}
                <div className="hm-card mb-4" style={{ boxShadow: "none" }}>
                  <div style={{ overflowX: "auto" }}>
                    <table className="hm-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Candidate Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Gender</th>
                          <th>Date of Birth</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {savedDetailsList.length === 0 ? (
                          <tr>
                            <td colSpan="7">
                              <div className="hm-empty-state py-4">
                                <i className="material-icons">group_add</i>
                                <p>No candidates added yet. Click "+ Add Candidate" to add user details.</p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          savedDetailsList.map((detail, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td className="fw-semibold">{detail.fullName}</td>
                              <td>{detail.email}</td>
                              <td>{detail.phoneNumber}</td>
                              <td>
                                <span className="hm-badge hm-badge-info">{detail.gender}</span>
                              </td>
                              <td>{detail.dob}</td>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <button
                                    type="button"
                                    className="btn btn-outline-info btn-sm rounded-pill py-1 px-2.5 d-flex align-items-center gap-1"
                                    onClick={() => handleViewUser(detail)}
                                    title="View/Edit"
                                  >
                                    <FontAwesomeIcon icon={faEye} />
                                    <span style={{ fontSize: "0.75rem" }}>View</span>
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-outline-danger btn-sm rounded-pill py-1 px-2.5 d-flex align-items-center gap-1"
                                    onClick={() => handleRemoveUser(index)}
                                    title="Remove"
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                    <span style={{ fontSize: "0.75rem" }}>Remove</span>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Footer Submit Action */}
                <div className="d-flex justify-content-end pt-2">
                  <button type="submit" className="btn-hm-primary py-2 px-4" disabled={loading}>
                    <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                    {loading ? "Submitting..." : "Submit Appointments"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {isAddUserModalOpen && (
        <AddPemeDetails
          isOpen={isAddUserModalOpen}
          onRequestClose={handleCloseAddUserModal}
          onSave={handleSaveDetails}
          userDetails={selectedUser}
        />
      )}
    </div>
  );
}

export default BookPemeAppointments;

